document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.wiki_list_contents_wrap');

  faqItems.forEach(item => {
    const title = item.querySelector('.news_faq_contents_title');
    const contents = item.querySelector('.news_faq_contents');
    const arrow = item.querySelector('.arrow img');

    if (!title || !contents || !arrow) {
      console.error('要素が見つかりません:', item);
      return;
    }

    title.addEventListener('click', () => {
      contents.classList.toggle('open');
      arrow.classList.toggle('rotate');
      title.classList.toggle('none_border');
    });
  });

const tagButtons = document.querySelectorAll(".tag_button");
const articles = document.querySelectorAll(".wiki_list_contents_wrap");

tagButtons.forEach(button => {
  button.addEventListener("click", () => {
    tagButtons.forEach(btn => btn.classList.remove("on_tag_category"));
    button.classList.add("on_tag_category");

    const selectedTagId = button.id;

    articles.forEach(article => {
      const title = article.querySelector(".article_title");
      if (!title) return;

      const tags = Array.from(article.querySelectorAll(".article_tag")).map(tag =>
        tag.textContent.trim()
      );

      article.style.display = selectedTagId === "all" || tags.includes(selectedTagId) ? "" : "none";
    });
  });
});

// 初期表示で「all」がなければ先頭のタブをクリック
(document.querySelector('#all') || document.querySelector('.tag_button'))?.click();
  
});
